import { Spin } from "antd";
import React, { Component } from "react";

class VHSpinner extends Component {
	render() {
		return (
			<div className="v-h-centered-container">
				<Spin size="large" tip="Loading..." />
			</div>
		);
	}
}

export default VHSpinner;
